import React, {Component} from "react";
import {Menu} from "antd";
import {Link} from "react-router-dom";

import CustomScrollbars from "util/CustomScrollbars";
import SidebarLogo from "./SidebarLogo";

import Auxiliary from "util/Auxiliary";
import UserProfile from "./UserProfile";
import AppsNavigation from "./AppsNavigation";
import {
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  THEME_TYPE_LITE
} from "../../constants/ThemeSetting";
import IntlMessages from "../../util/IntlMessages";
import {connect} from "react-redux";

const SubMenu = Menu.SubMenu;
const MenuItemGroup = Menu.ItemGroup;


class SidebarContent extends Component {

  getNoHeaderClass = (navStyle) => {
    if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR || navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR) {
      return "gx-no-header-notifications";
    }
    return "";
  };
  getNavStyleSubMenuClass = (navStyle) => {
    if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR) {
      return "gx-no-header-submenu-popup";
    }
    return "";
  };

  render() {
    const {themeType, navStyle, pathname, applications, type} = this.props;
    console.log('this.props', this.props);
    console.log('pathname', pathname);
    const selectedKeys = pathname.substr(1);
    const defaultOpenKeys = selectedKeys.split('/')[1];
    return (
      <Auxiliary>
        <SidebarLogo/>
        <div className="gx-sidebar-content">
          <div className={`gx-sidebar-notifications ${this.getNoHeaderClass(navStyle)}`}>
            <AppsNavigation/>
          </div>
          <CustomScrollbars className="gx-layout-sider-scrollbar">
            <Menu
              defaultOpenKeys={[defaultOpenKeys]}
              selectedKeys={[selectedKeys]}
              theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
              mode="inline">

              <MenuItemGroup key="social-apps" className="gx-menu-group" title={<IntlMessages id="sidebar.main"/>}>
                {applications && applications.length > 0 && <Menu.Item key="social-apps/dashboard">
                  <Link to="/social-apps/dashboard">
                    <i className="icon icon-chart-area"/>
                    <IntlMessages id="sidebar.dashboard"/>
                  </Link>
                </Menu.Item>}
                <Menu.Item key="social-apps/accounts">
                  <Link to="/social-apps/accounts">
                    <i className="icon icon-avatar -flex-column-reverse"/>
                    Account
                  </Link>
                </Menu.Item>

                {applications && applications.length > 0 &&
                <Menu.Item key="social-apps/application">
                  <Link to="/social-apps/application">
                    <i className="icon icon-apps"/>
                    <IntlMessages id="sidebar.application"/>
                  </Link>
                </Menu.Item>}
                {applications && applications.length > 0 &&
                  <Menu.Item key="social-apps/devices">
                  <Link to="/social-apps/devices">
                    <i className="icon icon-tag"/>
                    <IntlMessages id="sidebar.devices"/>
                  </Link>
                </Menu.Item>
                }
                {applications && applications.length > 0 &&
                <Menu.Item key="social-apps/minisites">
                  <Link to="/social-apps/minisites">
                    <i className="icon icon-sweet-alert"/>
                    <IntlMessages id="sidebar.minisites"/>
                  </Link>
                </Menu.Item>
                }
                {applications && applications.length > 0 &&
                <Menu.Item key="social-apps/customers">
                  <Link to="/social-apps/customers">
                    <i className="icon icon-profile"/>
                    Customers
                  </Link>
                </Menu.Item>
                }
                {applications && applications.length > 0 &&
                <Menu.Item key="social-apps/attendances">
                  <Link to="/social-apps/attendances">
                    <i className="icon icon-calendar"/>
                    Attendances
                  </Link>
                </Menu.Item>
                }
                {applications && applications.length > 0 &&
                <Menu.Item key="social-apps/mesh-networks">
                  <Link to="/social-apps/mesh-networks">
                    <i className="icon icon-map-clustering"/>
                    Mesh Networks
                  </Link>
                </Menu.Item>
                }
              </MenuItemGroup>

              <MenuItemGroup key="documents" className="gx-menu-group" title={<IntlMessages id="sidebar.documents"/>}>

                <Menu.Item key="documents/changelog">
                  <Link to="/documents/changelog">
                    <i className="icon icon-timeline-new"/>
                    <IntlMessages id="sidebar.documents.changelog"/>
                  </Link>
                </Menu.Item>

                <Menu.Item key="documents/system">
                  <Link to="/documents/system">
                    <i className="icon icon-extra-components"/>
                    <IntlMessages id="sidebar.documents.system"/>
                  </Link>
                </Menu.Item>

                <Menu.Item key="documents/installation">
                  <Link to="/documents/installation">
                    <i className="icon icon-steps"/>
                    <IntlMessages id="sidebar.documents.installation"/>
                  </Link>
                </Menu.Item>

              </MenuItemGroup>

              {type == 'super' && (
                <MenuItemGroup key="admin" className="gx-menu-group" title={<IntlMessages id="sidebar.admin"/>}>
                  <Menu.Item key="social-apps/admin">
                    <Link to="/social-apps/admin">
                      <i className="icon icon-crm"/>
                      Super Admin
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="social-apps/external-clients">
                    <Link to="/social-apps/external-clients">
                      <i className="icon icon-user-o"/>
                      External Clients
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="social-apps/device-batches">
                    <Link to="/social-apps/device-batches">
                      <i className="icon icon-product-grid"/>
                      Device Batches
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="social-apps/inventory">
                    <Link to="/social-apps/inventory">
                      <i className="icon icon-product-list"/>
                      Inventory
                    </Link>
                  </Menu.Item>
                </MenuItemGroup>
              )
              }
            </Menu>
          </CustomScrollbars>
        </div>
      </Auxiliary>
    );
  }
}

SidebarContent.propTypes = {};
const mapStateToProps = ({settings, auth, application}) => {
  console.log('settings', settings);
  const {navStyle, themeType, locale, pathname} = settings;
  const {authUser, type} = auth;
  const {applications} = application;
  console.log('authUser', authUser);
  return {navStyle, themeType, locale, pathname, auth, applications, type}
};
export default connect(mapStateToProps)(SidebarContent);
